export interface DynamicPlan {
  id: string;
  name: string;
  priceMonthly: number;
  priceAnnual: number;
  trialDays: number;
  storageGB: number;
  locutores: number | null;
  programs: number | null;
  events: number | null;
  lives: number | null;
  notifications: number | null;
  frequencyPreferred: boolean;
  verification: boolean;
  customDomain: boolean;
  apps: boolean;
  active: boolean;
  visible: boolean;
  color: string;
  createdAt: string;
  updatedAt: string;
}

export interface RadioPlanAssignment {
  id: number;
  radioName: string;
  frequency: string;
  planId: string;
  storageTotalGB: number;
  storageUsedGB: number;
  imagesCount: number;
  videosCount: number;
  postsCount: number;
  listenersThisMonth: number;
  upgradedAt: string;
  expiryDate: string;
  status: 'active' | 'trial' | 'expired';
}

export const planDefinitions: DynamicPlan[] = [
  {
    id: 'plan_free',
    name: 'Free',
    priceMonthly: 0,
    priceAnnual: 0,
    trialDays: 0,
    storageGB: 1,
    locutores: 1,
    programs: 0,
    events: 0,
    lives: 0,
    notifications: 0,
    frequencyPreferred: false,
    verification: false,
    customDomain: false,
    apps: false,
    active: true,
    visible: true,
    color: '#78716c',
    createdAt: '2025-01-15',
    updatedAt: '2026-05-20',
  },
  {
    id: 'plan_basico',
    name: 'Básico',
    priceMonthly: 9,
    priceAnnual: 90,
    trialDays: 14,
    storageGB: 10,
    locutores: 3,
    programs: 2,
    events: 1,
    lives: 0,
    notifications: 100,
    frequencyPreferred: false,
    verification: false,
    customDomain: false,
    apps: false,
    active: true,
    visible: true,
    color: '#0ea5e9',
    createdAt: '2025-01-15',
    updatedAt: '2026-05-20',
  },
  {
    id: 'plan_empresarial',
    name: 'Empresarial',
    priceMonthly: 29,
    priceAnnual: 290,
    trialDays: 14,
    storageGB: 50,
    locutores: 10,
    programs: 10,
    events: 5,
    lives: 2,
    notifications: 500,
    frequencyPreferred: true,
    verification: true,
    customDomain: false,
    apps: false,
    active: true,
    visible: true,
    color: '#d97706',
    createdAt: '2025-01-15',
    updatedAt: '2026-05-20',
  },
  {
    id: 'plan_oro',
    name: 'Oro',
    priceMonthly: 59,
    priceAnnual: 590,
    trialDays: 7,
    storageGB: 100,
    locutores: 20,
    programs: null,
    events: 20,
    lives: 5,
    notifications: 2000,
    frequencyPreferred: true,
    verification: true,
    customDomain: true,
    apps: false,
    active: true,
    visible: true,
    color: '#7c3aed',
    createdAt: '2025-03-10',
    updatedAt: '2026-05-20',
  },
  {
    id: 'plan_regional',
    name: 'Regional',
    priceMonthly: 99,
    priceAnnual: 990,
    trialDays: 7,
    storageGB: 250,
    locutores: 50,
    programs: null,
    events: 50,
    lives: 10,
    notifications: 5000,
    frequencyPreferred: true,
    verification: true,
    customDomain: true,
    apps: true,
    active: true,
    visible: true,
    color: '#1c1917',
    createdAt: '2025-03-10',
    updatedAt: '2026-05-20',
  },
  {
    id: 'plan_nacional',
    name: 'Nacional',
    priceMonthly: 199,
    priceAnnual: 1990,
    trialDays: 7,
    storageGB: 500,
    locutores: null,
    programs: null,
    events: null,
    lives: null,
    notifications: null,
    frequencyPreferred: true,
    verification: true,
    customDomain: true,
    apps: true,
    active: true,
    visible: true,
    color: '#dc2626',
    createdAt: '2025-06-01',
    updatedAt: '2026-04-15',
  },
  {
    id: 'plan_ilimitado',
    name: 'Ilimitado',
    priceMonthly: 399,
    priceAnnual: 3990,
    trialDays: 30,
    storageGB: 1024,
    locutores: null,
    programs: null,
    events: null,
    lives: null,
    notifications: null,
    frequencyPreferred: true,
    verification: true,
    customDomain: true,
    apps: true,
    active: false,
    visible: false,
    color: '#e11d48',
    createdAt: '2025-06-01',
    updatedAt: '2026-04-15',
  },
];

export const radioPlanAssignments: RadioPlanAssignment[] = [
  {
    id: 1,
    radioName: 'Radio Nueva Actitud',
    frequency: '87.90 RFW',
    planId: 'plan_nacional',
    storageTotalGB: 500,
    storageUsedGB: 387.2,
    imagesCount: 1840,
    videosCount: 42,
    postsCount: 315,
    listenersThisMonth: 89200,
    upgradedAt: '2025-03-15',
    expiryDate: '2027-03-15',
    status: 'active',
  },
  {
    id: 2,
    radioName: 'Stereo Visión',
    frequency: '94.70 RFW',
    planId: 'plan_nacional',
    storageTotalGB: 500,
    storageUsedGB: 421.5,
    imagesCount: 2310,
    videosCount: 67,
    postsCount: 450,
    listenersThisMonth: 124500,
    upgradedAt: '2025-01-10',
    expiryDate: '2027-01-10',
    status: 'active',
  },
  {
    id: 3,
    radioName: 'TechBeats',
    frequency: '88.50 RFW',
    planId: 'plan_empresarial',
    storageTotalGB: 50,
    storageUsedGB: 43.8,
    imagesCount: 520,
    videosCount: 0,
    postsCount: 180,
    listenersThisMonth: 34000,
    upgradedAt: '2025-06-20',
    expiryDate: '2026-06-20',
    status: 'active',
  },
  {
    id: 4,
    radioName: 'Radio Élite Digital',
    frequency: '91.30 RFW',
    planId: 'plan_empresarial',
    storageTotalGB: 50,
    storageUsedGB: 46.2,
    imagesCount: 780,
    videosCount: 0,
    postsCount: 210,
    listenersThisMonth: 28600,
    upgradedAt: '2025-08-01',
    expiryDate: '2026-08-01',
    status: 'active',
  },
  {
    id: 5,
    radioName: 'Radio Deportiva Total',
    frequency: '101.70 RFW',
    planId: 'plan_oro',
    storageTotalGB: 100,
    storageUsedGB: 78.1,
    imagesCount: 340,
    videosCount: 12,
    postsCount: 165,
    listenersThisMonth: 41200,
    upgradedAt: '2025-11-15',
    expiryDate: '2026-11-15',
    status: 'active',
  },
  {
    id: 6,
    radioName: 'Radio Sonora Digital',
    frequency: '96.20 RFW',
    planId: 'plan_free',
    storageTotalGB: 1,
    storageUsedGB: 0.92,
    imagesCount: 0,
    videosCount: 0,
    postsCount: 0,
    listenersThisMonth: 5200,
    upgradedAt: '2026-02-01',
    expiryDate: '—',
    status: 'trial',
  },
  {
    id: 7,
    radioName: 'Radio Urbana 101',
    frequency: '103.50 RFW',
    planId: 'plan_nacional',
    storageTotalGB: 500,
    storageUsedGB: 156.8,
    imagesCount: 920,
    videosCount: 28,
    postsCount: 230,
    listenersThisMonth: 67800,
    upgradedAt: '2025-04-01',
    expiryDate: '2027-04-01',
    status: 'active',
  },
  {
    id: 8,
    radioName: 'Clásica FM',
    frequency: '99.10 RFW',
    planId: 'plan_free',
    storageTotalGB: 1,
    storageUsedGB: 0.78,
    imagesCount: 0,
    videosCount: 0,
    postsCount: 0,
    listenersThisMonth: 12000,
    upgradedAt: '2025-12-10',
    expiryDate: '—',
    status: 'active',
  },
  {
    id: 9,
    radioName: 'Radio Folclor Andino',
    frequency: '107.90 RFW',
    planId: 'plan_basico',
    storageTotalGB: 10,
    storageUsedGB: 4.4,
    imagesCount: 215,
    videosCount: 0,
    postsCount: 72,
    listenersThisMonth: 15600,
    upgradedAt: '2026-01-05',
    expiryDate: '2027-01-05',
    status: 'active',
  },
  {
    id: 10,
    radioName: 'Radio Marítima',
    frequency: '89.50 RFW',
    planId: 'plan_free',
    storageTotalGB: 1,
    storageUsedGB: 0.65,
    imagesCount: 0,
    videosCount: 0,
    postsCount: 0,
    listenersThisMonth: 7800,
    upgradedAt: '2026-04-20',
    expiryDate: '—',
    status: 'active',
  },
  {
    id: 11,
    radioName: 'Jazz Club Radio',
    frequency: '92.80 RFW',
    planId: 'plan_empresarial',
    storageTotalGB: 50,
    storageUsedGB: 38.9,
    imagesCount: 490,
    videosCount: 0,
    postsCount: 145,
    listenersThisMonth: 22300,
    upgradedAt: '2025-09-12',
    expiryDate: '2026-09-12',
    status: 'active',
  },
  {
    id: 12,
    radioName: 'Radio Éxitos TV',
    frequency: '100.00 RFW',
    planId: 'plan_oro',
    storageTotalGB: 100,
    storageUsedGB: 89.4,
    imagesCount: 1580,
    videosCount: 35,
    postsCount: 390,
    listenersThisMonth: 94500,
    upgradedAt: '2025-02-28',
    expiryDate: '2027-02-28',
    status: 'active',
  },
];

export const totalStorage = {
  assigned: radioPlanAssignments.reduce((sum, r) => sum + r.storageTotalGB, 0),
  used: radioPlanAssignments.reduce((sum, r) => sum + r.storageUsedGB, 0),
};

export function getPlanById(id: string): DynamicPlan | undefined {
  return planDefinitions.find((p) => p.id === id);
}

export function getPlanName(id: string): string {
  return planDefinitions.find((p) => p.id === id)?.name ?? 'Desconocido';
}

export function getPlanColor(id: string): string {
  return planDefinitions.find((p) => p.id === id)?.color ?? '#78716c';
}

export function formatStorage(gb: number): string {
  if (gb >= 1000) return `${(gb / 1024).toFixed(1)} TB`;
  return `${gb} GB`;
}

export function formatPlanValue(val: number | null): string {
  if (val === null) return 'Ilimitado';
  return val.toString();
}